export { ContentBox, ContentBoxProps } from './content-box'
